/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../../../_chunks/dep-89b33ff6.mjs';
import { _ as _classCallCheck, a as _createClass } from '../../../_chunks/dep-6d195cc7.mjs';
import { _ as _defineProperty } from '../../../_chunks/dep-a26b9c60.mjs';
import { getIEVersion } from '../utils/helper.mjs';
import '../../../_chunks/dep-6bcce672.mjs';
import '../../../_chunks/dep-b333ab93.mjs';
import '../../../_chunks/dep-f7837681.mjs';
import '../../../_chunks/dep-9c7a32ff.mjs';
import '../../../_chunks/dep-5f6c8826.mjs';
import '../../../_chunks/dep-6f3e4f56.mjs';
import '../../../_chunks/dep-b1060562.mjs';
import '../../../_chunks/dep-0d1bd08c.mjs';
import '../../../_chunks/dep-c5d88cfe.mjs';
import '../../../_chunks/dep-8049d2e0.mjs';
import '../../../_chunks/dep-c45cdd10.mjs';
import '../../../_chunks/dep-ce88e3c0.mjs';
import '../../../_chunks/dep-a432d90f.mjs';

var quartOut = function quartOut(t) {
  return 1 - Math.abs(Math.pow(t - 1, 4));
};
var Tween = /*#__PURE__*/function () {
  function Tween(_ref) {
    var _this = this;
    var from = _ref.from,
      to = _ref.to,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 200 : _ref$duration,
      onStart = _ref.onStart,
      _ref$onUpdate = _ref.onUpdate,
      onUpdate = _ref$onUpdate === void 0 ? function () {} : _ref$onUpdate,
      onFinish = _ref.onFinish;
    _classCallCheck(this, Tween);
    _defineProperty(this, "from", void 0);
    _defineProperty(this, "to", void 0);
    _defineProperty(this, "duration", void 0);
    _defineProperty(this, "onStart", void 0);
    _defineProperty(this, "onUpdate", void 0);
    _defineProperty(this, "onFinish", void 0);
    _defineProperty(this, "startTime", void 0);
    _defineProperty(this, "started", void 0);
    _defineProperty(this, "finished", void 0);
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "keys", void 0);
    _defineProperty(this, "time", 0);
    _defineProperty(this, "elapsed", 0);
    this.from = from;
    this.to = to;
    this.duration = duration;
    this.onStart = onStart;
    this.onUpdate = onUpdate;
    this.onFinish = onFinish;
    this.startTime = Date.now();
    this.started = false;
    this.finished = false;
    this.timer = null;
    this.keys = {};
    Object.entries(from).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      if (_this.to[key] === void 0) {
        _this.to[key] = value;
      }
    });
    Object.entries(to).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];
      if (_this.from[key] === void 0) {
        _this.from[key] = value;
      }
    });
  }
  _createClass(Tween, [{
    key: "update",
    value: function update() {
      var _this2 = this;
      this.time = Date.now();
      if (this.time < this.startTime || this.finished) return;
      if (this.elapsed >= this.duration) {
        var _this$onFinish;
        this.finished = true;
        (_this$onFinish = this.onFinish) === null || _this$onFinish === void 0 || _this$onFinish.call(this, this.keys);
        return;
      }
      var elapsed = Math.min(this.time - this.startTime, this.duration);
      this.elapsed = elapsed;
      var progress = quartOut(elapsed / this.duration);
      Object.keys(this.to).forEach(function (key) {
        var delta = _this2.to[key] - _this2.from[key];
        _this2.keys[key] = _this2.from[key] + delta * progress;
      });
      if (!this.started) {
        var _this$onStart;
        (_this$onStart = this.onStart) === null || _this$onStart === void 0 || _this$onStart.call(this, this.keys);
        this.started = true;
      }
      this.onUpdate(this.keys);
    }
  }, {
    key: "polyfillStart",
    value: function polyfillStart() {
      var _this3 = this;
      var elapsed = Date.now() - this.startTime;
      var interval = quartOut(elapsed / this.duration);
      this.timer = setInterval(function () {
        _this3.update();
        if (_this3.finished) {
          clearInterval(_this3.timer);
        }
      }, interval);
    }
  }, {
    key: "normalStart",
    value: function normalStart() {
      var _this4 = this;
      var tick = function tick() {
        _this4.update();
        _this4.timer = requestAnimationFrame(tick);
        if (_this4.finished) {
          cancelAnimationFrame(_this4.timer);
          _this4.timer = null;
        }
      };
      tick();
    }
  }, {
    key: "start",
    value: function start() {
      this.startTime = Date.now();
      if (getIEVersion() < 10) this.polyfillStart();else this.normalStart();
    }
  }, {
    key: "stop",
    value: function stop() {
      if (getIEVersion() < 10) clearInterval(this.timer);else cancelAnimationFrame(this.timer);
      this.timer = null;
    }
  }]);
  return Tween;
}();

export { Tween as default };
//# sourceMappingURL=tween.mjs.map
